import {useInView} from "react-intersection-observer";
import {useFetchOffers} from "../../../hooks/useOffers";
import {useMe} from "../../../hooks/useGetUser";
import {userRoleList} from "../../../utils/constants";
import newPost from "../../../images/newPost.png";
import {Link} from "react-router-dom";
import {useChatRooms} from "../../../hooks/useChat";
import Loader from "../../components/shared/Loader";
import ImageComponent from "../../components/shared/ImageComponent";
import {useDailyIntervention} from "../../../hooks/useInterventions";
import {
  InterventionCardTech,
  InterventionCardTechDirect,
} from "./interventionCard";
import {useGetCatgeory} from "../../../hooks/useCategory";
import {useMemo} from "react";
import {DateGroupedIntervention} from "../../../utils/date";
import QueryErrorState from "../../components/shared/QueryErrorState";
import EmptyState from "../../components/shared/EmptyState";

const ListCardIntervention = ({filter}) => {
  const {data, isLoading: isMeLoading} = useMe();
  const {
    data: chatrooms,
    isLoading: ischatloading,
    isError: ischatEroor,
  } = useChatRooms();

  // Chatrooms logging
  const {interventions, isError, error, isLoading, refetch} = useDailyIntervention({
    ...filter,
  });

  const {data: categories, isLoading: isCategoryLoading} = useGetCatgeory();

  const groupByStartDate = (interventions) => {
    return interventions.reduce((groups, intervention) => {
      const startDate = DateGroupedIntervention(intervention?.startDate); // Ensure pubDate is properly formatted
      if (!groups[startDate]) {
        groups[startDate] = [];
      }
      groups[startDate].push(intervention);
      return groups;
    }, {});
  };
  const groupedInterventions = useMemo(() => {
    if (interventions) {
      return groupByStartDate(interventions);
    } else {
      return [];
    }
  }, [interventions]);
  // Grouped interventions logging

  if (isLoading || isMeLoading || ischatloading || isCategoryLoading) {
    return <Loader />;
  }

  if (isError || ischatEroor) {
    return <QueryErrorState error={error} onRetry={refetch} />;
  }
  if (interventions?.length === 0) {
    return (
      <EmptyState className="w-full py-3 min-h-[56vh] rounded-2xl bg-white" />
    );
  }

  return (
    <>
      {Object.entries(groupedInterventions).map(([pubDate, interventions]) => (
        <div key={pubDate} className="mb-4 flex flex-col w-full gap-3">
          <div className="text-[14px] leading-4 font-medium  text-[#19295C] ">
            {pubDate}
          </div>
          {interventions.map((intervention, index) => (
            <div className="w-full" key={index}>
              {!!intervention?.Offer_Proposal?.Offer ? (
                <InterventionCardTech
                  categories={categories}
                  intervention={intervention}
                  chatroom={chatrooms.find(
                    (el) =>
                      el?.indirectChat?.offerId ===
                      intervention?.Offer_Proposal?.Offer?.id,
                  )}
                />
              ) : (
                <InterventionCardTechDirect
                  intervention={intervention}
                  chatroom={intervention?.Offer_Proposal?.directChat?.chatroom}
                />
              )}
            </div>
          ))}
        </div>
      ))}
    </>
  );
};

export default ListCardIntervention;
